import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Agreement } from '../../../../../../shared/utils/agreement';
import { AgreementModal } from '../../../../common/components/AgreementModal';

import { AgreementItem, AgreementsWrapper } from './styledComponents';

type SignUpAgreements =
  | Agreement.termsOfServiceV2
  | Agreement.personalInformationV2;

interface AgreementsProps {
  onChangeSatisfied: (satisfied: boolean) => void;
}
export const AgreementsEn = (props: AgreementsProps) => {
  const { onChangeSatisfied } = props;
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.signup.inputs.agreement',
  });
  const [confirmTarget, setConfirmTarget] = useState<
    SignUpAgreements | undefined
  >(undefined);
  const [agreements, setAgreements] = useState({
    [Agreement.termsOfServiceV2]: false,
    [Agreement.personalInformationV2]: false,
  });
  const satisfied = Object.values(agreements).reduce(
    (accum, curr) => accum && curr,
    true,
  );

  const getShowAgreement = (type: SignUpAgreements) => () => {
    setConfirmTarget(type);
  };

  const getUpdateAgreement = (type: SignUpAgreements) => (value: boolean) => {
    setAgreements(prev => ({
      ...prev,
      [type]: value,
    }));
  };

  const updateAllAgreements = (checked: boolean) => {
    setAgreements({
      [Agreement.termsOfServiceV2]: checked,
      [Agreement.personalInformationV2]: checked,
    });
  };

  useEffect(() => {
    onChangeSatisfied(satisfied);
  }, [satisfied, onChangeSatisfied]);

  return (
    <AgreementsWrapper>
      <AgreementItem
        label={`${t('agreeAll')}`}
        checked={satisfied}
        onToggle={updateAllAgreements}
        bold
      />
      {Object.keys(agreements).map((agreement: string) => (
        <AgreementItem
          key={agreement}
          label={`${t(`${agreement}.title`)} ${t(`${agreement}.postfix`)}`}
          checked={agreements[agreement as SignUpAgreements]}
          onToggle={getUpdateAgreement(agreement as SignUpAgreements)}
          onShowAgreement={getShowAgreement(agreement as SignUpAgreements)}
        />
      ))}
      {confirmTarget && (
        <AgreementModal
          open={!!confirmTarget}
          onClose={() => setConfirmTarget(undefined)}
          onAllow={() => {
            getUpdateAgreement(confirmTarget)(true);
            setConfirmTarget(undefined);
          }}
          agreementType={confirmTarget}
        />
      )}
    </AgreementsWrapper>
  );
};
